export interface Bonus {
  image: string
  alt: string
  title: string
  price: string
}

export const bonuses: Bonus[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/bva3NvCb6HdaAUk1ckfFsS/edu_v1.webp',
    alt: 'Copertina del bonus Palestra Occupata? 50 attività pronte in aula, in corridoio e in cortile',
    title: 'Palestra Occupata? 50 Attività Pronte in Aula, in Corridoio e in Cortile',
    price: '27 €',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/wZCntccWZLR6NcbeDzu1yc/ed_v2.webp',
    alt: 'Copertina del bonus Kit Valutazione Pronta: griglie, rubriche e giudizi già scritti',
    title: 'Kit Valutazione Pronta: Griglie, Rubriche e Giudizi Già Scritti',
    price: '36 €',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/h3MFkwuQeY6Z8H4CEQXfJu/edu_v3.webp',
    alt: 'Copertina del bonus Movimento per Tutti: inclusione, BES, DSA e alunni esonerati',
    title: 'Movimento per Tutti: Inclusione, BES, DSA e Alunni Esonerati',
    price: '27 €',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/43QXHTCXmmp4u6RFwL4y5E/edu_v4.webp',
    alt: 'Copertina del bonus La Giornata Sportiva: festa dello sport organizzata in 7 giorni',
    title: 'La Giornata Sportiva: Festa dello Sport Organizzata in 7 Giorni',
    price: '19 €',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/vvXiaqGs3sBLN6uprJUgnR/edu_v5.webp',
    alt: 'Copertina del bonus Sicurezza e Famiglie: normativa, esoneri e comunicazioni pronte',
    title: 'Sicurezza e Famiglie: Normativa, Esoneri e Comunicazioni Pronte',
    price: '19 €',
  },
]
